import { Spin } from 'antd';
import { useLocation } from 'react-router-dom';
import qs from 'query-string';
import { useRequest } from 'ahooks';
import '../MajorProjectTimeline.less';
import SubjectBasicInfo from './componments/SubjectBasicInfo';
import ProjectBasicInfo from './componments/ProjectBasicInfo';
import UserLogs from './componments/UserLogs';
import { getDeclarationData } from '@/services/agriculturalSubsidies';
import { getDictType } from '@/services/common';
import { SPECIAL_AGRICULTURAL_TYPE, SPECIAL_ENTER_NAME, SPECIAL_PROJECT_NAME } from '@/utils/mappingDict';

const defaultParams = [SPECIAL_PROJECT_NAME, SPECIAL_AGRICULTURAL_TYPE, SPECIAL_ENTER_NAME].join(',');
export default function IndustryBankLoanTimeline() {
  const { search } = useLocation();
  const { id } = qs.parse(search);

  const { data: dict = {} } = useRequest(getDictType, { defaultParams: [defaultParams] });

  const { loading, data } = useRequest(() => getDeclarationData(id));

  return (
    <Spin spinning={loading}>
       <SubjectBasicInfo data={data} dict={dict} />
        <ProjectBasicInfo data={data} dict={dict} />
        <UserLogs userLogs={data?.userLogs || []} />
    </Spin>
  );
}
